import en from './en.json'
import it from './it.json'

export const defaultLocale = 'it'

export const languages = {
  en,
  it
}